import {action, computed, makeObservable, observable} from 'mobx'
import BaseModel from './BaseModel'
import {post} from "../common/requester";

export default class Competition extends BaseModel {
  constructor(store) {
    super(store)
    makeObservable(this, {
      id: observable,
      name: observable,
      company_id: observable,
      sport_id: observable,
      address: observable,
      location: observable,
      start_date: observable,
      end_date: observable,
      fee: observable,
      teams: observable,
      regulations: observable,
      was_validated: computed,
      isValid: computed,
      save: action,
      pdf: observable,
      pdf_temp: observable,
      is_owner: observable,
      is_invited: observable,
      invite_status: observable,
      divisions: observable,
      companies: observable,
      companies_count: observable,
      country_text: observable,
      sport_icon: observable,
    })
  }

  id = 0
  name = ''
  company_id = 0
  sport_id = 0
  address = ''
  location = {}
  start_date = new Date()
  end_date = null
  fee = 0
  regulations = ''
  pdf = null
  pdf_temp = null
  
  is_owner = false
  is_invited = false
  invite_status = null
  divisions = []
  companies = null
  companies_count = 0
  country_text = ''
  sport_icon = ''

  // Expected shape for billing page:
  // teams = [
  //   {
  //     id,
  //     name,
  //     members: [
  //       {
  //         id,
  //         company_user_id,
  //         title,
  //         is_billed,
  //         bill_id
  //       }
  //     ]
  //   }
  // ]
  teams = []

  get was_validated() {
    return true
  }

  get isValid() {
    return this.company_id &&
      this.sport_id &&
      this.name &&
      this.address &&
      this.start_date &&
      this.location.lat &&
      this.location.lng
  }

  async save() {
    if (this.isValid) {
      const data = {
        id: this.id,
        name: this.name,
        company_id: this.company_id,
        sport_id: this.sport_id,
        address: this.address,
        location: this.location,
        start_date: this.start_date,
        end_date: this.end_date,
        fee: this.fee,
        regulations: this.regulations,
        pdf: this.pdf_temp
      }
      const ret = await post('game/save_tournament', data).catch(e => console.error(e))
      if (ret && ret.result === 0) {
        this.fromJson(ret.tournament)
      }
    }
  }
}